import { apiClient } from './AbstractHTTPService'

const PATH = '/file/'

export default {
  getCategories () {
    return apiClient.get('/basedata/filecategory/')
  },

  download (data) {
    apiClient({
      method: 'GET',
      url: PATH + data.id + '/',
      responseType: 'blob'
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', data.sFilename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url)
      })
      .catch((e) => console.log(e))
  }
}
